import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { AccountProtocolModal } from './components/AccountProtocolModal';

export const AccountProtocol = ({ accountId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <Button
        onClick={() => {
          toggleModal();
        }}
        color="success"
        size="sm"
        title="Histórico de protocolos da Conta"
        disabled={!accountId}
      >
        <li className="fas fa-clock"></li>
      </Button>
      {isModalOpen ? (
        <AccountProtocolModal
          isModalOpen={isModalOpen}
          toggleModal={toggleModal}
          isProtocolScreen={false}
          accountId={accountId}
        />
      ) : null}
    </>
  );
};
